<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <div >
          <h3 class="card-title">{{$t('applications.applicant__ongoing')}}</h3>

          <div v-if="ongoing.length">
            <card  v-for="application in ongoing" v-bind:key="application.applicationId">
              <template slot="header">
                <h3 v-if="application.fp == 1 || application.cnEvaluationStatus == 'Preselected'" class="card-title">{{ application.description }}</h3>
                <h3 v-if="application.cnStatus == 'DRAFT'" class="card-title">Concept Note</h3>
                <!--<h3 v-if="application.cnEvaluationStatus == 'Preselected'" class="card-title">{{ application.description }}</h3>-->
                <h5 class="card-category">{{$t('applications.general__application_title')}}: <strong>{{application.title}}</strong></h5>
                <h5 class="card-category">{{$t('applications.general__application_reference')}}: <strong>{{application.reference}}</strong></h5>
                <h5 class="card-category">{{$t('general.created_date')}}: {{application.createdAt}}</h5>
                <h5 class="card-category">{{$t('general.last_update')}}: {{application.updatedAt}}</h5>
              </template>
              <base-button @click="goToApplication(application.grantId, application.applicationId,application.cnStatus,application.cnEvaluationStatus,application.newApplication)" type="primary" size="lg" simple>{{$t('general.complete')}}</base-button>
            </card>
          </div>
          
          <h4 v-if="!ongoing.length" class="card-title">{{$t('applications.applicant__empty_state')}}</h4>
        </div>

        <div >
          <h3 class="card-title">{{$t('applications.applicant__submitted')}}</h3>

          <div v-if="pending.length">
            <card  v-for="application in pending" v-bind:key="application.applicationId">
              <template slot="header">
                <h3 v-if="application.status == 'submitted'" class="card-title">{{ application.description }}</h3>
                <h3 v-if="application.cnStatus == 'SUBMITTED' && application.cnEvaluationStatus == null" class="card-title">Concept Note</h3>
                <h5 class="card-category">{{$t('applications.general__application_title')}}: <strong>{{application.title}}</strong></h5>
                <h5 class="card-category">{{$t('applications.general__application_reference')}}: <strong>{{application.reference}}</strong></h5>
                <h5 class="card-category">{{$t('general.submitted_date')}}: {{application.updatedAt}}</h5>
              </template>
              <base-button @click="goToApplication(application.grantId, application.applicationId,application.cnStatus,application.cnEvaluationStatus,application.newApplication)" type="primary" size="lg" simple>{{$t('general.view')}}</base-button>
            </card>
          </div>
          
          <h4 v-if="!pending.length" class="card-title">{{$t('applications.applicant__empty_state')}}</h4>
        </div>

        <div > 
          <h3 class="card-title">{{$t('applications.applicant__awarded')}}</h3>

          <div v-if="awarded.length">
            <card v-for="application in awarded" v-bind:key="application.applicationId">
              <template slot="header">
                <h3 class="card-title">{{ application.description }}</h3>
                <h5 class="card-category">{{$t('applications.general__application_title')}}: <strong>{{application.title}}</strong></h5>
                <h5 class="card-category">{{$t('applications.general__application_reference')}}: <strong>{{application.reference}}</strong></h5>
              </template>
            <base-button @click="goToApplication(application.applicationId)" type="primary" size="lg" simple>{{$t('general.view')}}</base-button>
            </card>
          </div>
          
          <h4 v-if="!awarded.length" class="card-title">{{$t('applications.applicant__empty_state')}}</h4>
        </div>

        <div >
          <!--<h3 class="card-title">{{$t('applications.applicant__rejected')}}</h3>-->
          <h3 class="card-title">{{$t('applications.applicant__unsuccessful')}}</h3>

          <div v-if="unsuccessful.length">
            <card v-for="application in unsuccessful" v-bind:key="application.applicationId">
              <template slot="header">
                <!--<h3 v-if="application.finalStatus == 'REJECTED'" class="card-title">{{ application.description }}</h3>-->
                <h3 v-if="application.cnEvaluationStatus == 'Rejected' || application.cnEvaluationStatus == 'Non-eligible'" class="card-title">Concept Note</h3>
                <h5 class="card-category">{{$t('applications.general__application_title')}}: <strong>{{application.title}}</strong></h5>
                <h5 class="card-category">{{$t('applications.general__application_reference')}}: <strong>{{application.reference}}</strong></h5>
              </template>
              <!--<base-button @click="goToApplication(application.applicationId)" type="primary" size="lg" simple>{{$t('general.view')}}</base-button>-->
              <base-button @click="goToApplication(application.grantId, application.applicationId,application.cnStatus,application.cnEvaluationStatus,application.newApplication)" type="primary" size="lg" simple>{{$t('general.view')}}</base-button>
            </card>           
          </div>
          
          <h4 v-if="!unsuccessful.length" class="card-title">{{$t('applications.applicant__empty_state')}}</h4>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="row">
          <div class="font-icon-list col-lg-12">
            <div @click="() => $router.push('/grants')" class="font-icon-detail application-button">
              <i class="tim-icons icon-notes"></i>
              <h4>{{ $t('applications.general__apply_for_new') }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {ApplicationService} from '@/services';
  import axios from "axios"

  export default {
    data() {
      return {
        initialized: false,
        applications: []
      };
    },
    computed: {
      ongoing() {
        return this.applications.filter(function (application) {
          return ((application.fp == 1 && application.status == 'draft')  || application.cnStatus == 'DRAFT' || (application.cnEvaluationStatus == 'Preselected' && application.status != 'submitted'));
        })
      },
      pending() {
        let filtered = this.applications.filter(function (application) {
          return (application.status == 'submitted' || (application.cnStatus == 'SUBMITTED' && application.cnEvaluationStatus == null));
        })
        
        return this._.orderBy(filtered, 'updatedAt', 'asc')
      },
      awarded() {
        return this.applications.filter(function (application) {
          return application.status == 'awarded';
          //return application.finalStatus == 'AWARDED';
        })
      },
      /*rejected() {
        return this.applications.filter(function (application) {
          return (application.status == 'rejected'|| application.cnEvaluationStatus == 'Rejected');
        })
      }*/
      unsuccessful() {
        return this.applications.filter(function (application) {
          return (application.cnEvaluationStatus == 'Rejected' || application.cnEvaluationStatus == 'Non-eligible');
        })
      }
    },
    methods: {
      goToApplication(grantId, applicationId, cnstatus,cnEvaluationStatus,newApplication) {
        if(cnstatus != null){
          if(cnEvaluationStatus == 'Preselected'){
              //this.$router.push('/application/fill/' + grantId + '/' + applicationId + '/' + cnEvaluationStatus);
              this.$router.push({
              name: "ConceptFill",
              params: { grantId: grantId, applicationId: applicationId, conceptStatus: cnEvaluationStatus },
              });
          }
          else{
              //this.$router.push('/application/fill/' + grantId + '/' + applicationId + '/' + "conceptNote");
              this.$router.push({
              name: "ConceptFill",
              params: { grantId: grantId, applicationId: applicationId, conceptStatus: "conceptNote" },
              });
          }
          
        }
        else{
          this.$router.push({
              name: "Fill",
              params: { grantId: grantId, applicationId: applicationId, appversion: newApplication },
              });
            //this.$router.push('/application/fill/' + grantId + '/' + applicationId);
        }
      },
      async getApplications() {
        let loader = this.$loading.show();
        ApplicationService.getOngoing().then((response) => {
          this.applications = response.data;
          this.initialized = true;
          loader.hide();
        })
      }
    },
    created() {
      this.getApplications();
    },
  };
</script>
<style lang="scss"></style>
